import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Menu, MenuItem, Box, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/Check';
import './LanguageSwitcher.css';

// A more robust data structure for our languages
export const LANGUAGES = [
  { code: 'en', name: 'English', flag: 'gb.svg' },
  { code: 'de', name: 'Deutsch', flag: 'de.svg' },
  { code: 'fr', name: 'Français', flag: 'fr.svg' },
  { code: 'it', name: 'Italiano', flag: 'it.svg' },
  { code: 'es', name: 'Español', flag: 'es.svg' },
  { code: 'pt', name: 'Português', flag: 'pt.svg' },
  { code: 'ja', name: '日本語', flag: 'ja.svg' },
  { code: 'zh', name: '中国人', flag: 'zh.svg' },
  { code: 'ko', name: '韓国人', flag: 'ko.svg' },
  { code: 'ru', name: 'Русский', flag: 'ru.svg' },
  { code: 'ar', name: 'عربي', flag: 'ar.svg' },
  { code: 'hi', name: 'हिन्दी', flag: 'hi.svg' },

];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    handleClose();
  };

  // Find the current language object. Use 'en' as a safe fallback.
  // The .startsWith() check handles cases like 'en-US' correctly.
  const currentLanguage = LANGUAGES.find(lang => i18n.language.startsWith(lang.code)) || LANGUAGES[0];

  return (
    <div>
      <Button
        className="language-switcher-button"
        onClick={handleClick}
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <img 
          src={`/static/flags/${currentLanguage.flag}`} 
          alt={`${currentLanguage.name} flag`}
          className="flag-icon" 
        />
        <ArrowDropDownIcon />
      </Button>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'language-switcher-button' }}
        PaperProps={{ className: 'language-menu-paper' }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={i18n.language.startsWith(lang.code)}
            onClick={() => changeLanguage(lang.code)}
            className="language-menu-item"
          >
            <Box className="menu-item-content">
              <img 
                src={`/static/flags/${lang.flag}`} 
                alt={`${lang.name} flag`} 
                className="flag-icon"
              />
              <Typography variant="body1" className="language-name">
                {lang.name.toUpperCase()}
              </Typography>
              {i18n.language.startsWith(lang.code) && (
                <CheckIcon className="selected-check-icon" />
              )}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default LanguageSwitcher;

export const LanguageMenuItemContent = ({ lang, isSelected }) => {
  return (
    <Box className="menu-item-content">
      <img 
        src={`/static/flags/${lang.flag}`} 
        alt={`${lang.name} flag`} 
        className="flag-icon"
      />
      <Typography variant="body1" className="language-name">
        {lang.name.toUpperCase()}
      </Typography>
      {isSelected && (
        <CheckIcon className="selected-check-icon" />
      )}
    </Box>
  );
};